import Table from 'react-bootstrap/Table';
import { useTable, useSortBy } from 'react-table';
import { useMemo, useState } from 'react';
import CompetitionStatus from './CompetitionStatus';
import { useNavigate } from 'react-router-dom';
import usePaginatedTable from '../../hooks/UsePaginatedTable';
import PaginationSection from '../../components/pagination/PaginationSection';
import { Button } from 'react-bootstrap';

function CompetitionsTable({
  competitions,
  onDeleteDraft,
  rowsPerPage,
  onCancel,
}) {
  // Pagination
  const [page, setPage] = useState(1);
  const { slice, range } = usePaginatedTable(competitions, page, rowsPerPage);

  const data = useMemo(() => slice, [competitions, slice]);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: 'Tävling',
        accessor: 'name', // accessor is the "key" in the data
        className: 'p-3',
        style: { width: '40%' },
      },
      {
        Header: 'Tävlingsdatum',
        accessor: 'startDate',
        className: 'p-3',
        Cell: ({ cell: { value } }) =>
          value ? new Date(value).toLocaleDateString('sv-SE') : '-',
      },
      {
        Header: 'Status',
        accessor: 'status',
        className: 'p-3',
        Cell: (props) => (
          <span onClick={(e) => e.stopPropagation()}>
            <CompetitionStatus
              status={props.row.original.status}
              id={props.row.original.id}
              onDeleteDraft={onDeleteDraft}
            />
          </span>
        ),
      },
      {
        Header: 'Sista anmälningsdag',
        accessor: 'deadline',
        className: 'p-3',
        Cell: ({ cell: { value } }) =>
          value ? new Date(value).toLocaleDateString('sv-SE') : '-',
      },

      {
        Header: 'Antal anmälda',
        accessor: 'registeredParticipants',
        className: 'p-3',
        Cell: ({ cell: { value } }) => value,
      },
      {
        Header: '',
        id: 'cancel-competition',
        className: 'p-3',
        Cell: (props) => {
          const status = props.row.original.status;
          return (
            <div
              onClick={(e) => e.stopPropagation()}
              className='d-flex justify-content-center'
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onCancel(props.row.original.id);
                }}
                disabled={status !== 'Kommande'}
              >
                Ställ in tävling
              </Button>
            </div>
          );
        },
      },
    ],
    [competitions]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <div className='d-flex flex-column w-100'>
      <Table
        {...getTableProps()}
        style={{
          borderCollapse: 'separate',
          borderSpacing: '0 0.5rem',
          width: '100%',
        }}
        className='table-borderless'
        hover
      >
        <thead className='bg-divider'>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className='bg-white'
                style={{ borderStyle: 'none' }}
                role='button'
                onClick={() => {
                  const competitionId = row?.original?.id;

                  if (competitionId) {
                    navigate(`./${competitionId}/details`);
                  }
                }}
              >
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className={cell.column.className}
                      style={cell.column.style}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <PaginationSection
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
      />
    </div>
  );
}

export default CompetitionsTable;
